import { FC } from 'react';
import { IconTooltip } from './IconTooltip';
import { IconTooltipProps } from './model/IconTooltipProps';

type Props = Omit<IconTooltipProps, 'name'>;

export const InfoIconTooltip: FC<Props> = ({ onlyClickable, title, color = 'info', ...props }) => (
  <IconTooltip name="infoFilled" ml={0.3} color={color} title={title} onlyClickable={onlyClickable} {...props} />
);
